/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { useTreeMutationForm } from "../react-hook/use-tree-mutation-form";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
// import { SelectInput } from "@/components/ui/select-input";
import { SelectWithSearch } from "@/components/form-input";
import { ErpMappingComponent } from "../erp-mapping-component/erp-mapping-component";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const TreeDetailsForm = ({
  formData,
  type,
  defaultValue,
  onTreeFormSubmit,
  erp_mapping_value,
  erpListData,
  orderTypeList,
  order_type,
  parentOrderType,
  entityCardinality,
}: any) => {
  const { form, onSubmit } = useTreeMutationForm({
    formData,
    onFormSubmit: onTreeFormSubmit,
    defaultValue,
    erp_mapping_value,
    order_type,
    cardinality: entityCardinality,
  });
  return (
    <div>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <FormField
            control={form.control}
            name="name"
            render={({ field, fieldState }) => (
              <FormItem className="w-full text-left grid grid-cols-2 border items-center">
                <FormLabel className="capitalize pl-3">Name</FormLabel>
                <FormControl>
                  <Input
                    className={cn(
                      "!mt-0 rounded-none  bg-white",
                      fieldState?.error
                        ? "border-red-500"
                        : "border-r-0 border-t-0 border-b-0"
                    )}
                    placeholder={`${type} name`}
                    onBlur={() => {
                      form.handleSubmit(onSubmit)();
                      if (field.value === "") {
                        field.onChange(defaultValue);
                      }
                    }}
                    onChange={(e) => {
                      field.onChange(
                        e.target.value.replace(" ", "_").toLowerCase()
                      );
                      if (e.target.value !== "") {
                        form.handleSubmit(onSubmit)();
                      }
                    }}
                    value={field.value}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <ConditionRenderer condition={type === "attribute"}>
            <FormField
              control={form.control}
              name="erp_mapping"
              render={({ field }) => (
                <FormItem className="w-full text-left grid grid-cols-2 border items-center">
                  <FormLabel className="capitalize pl-3">Erp mapping</FormLabel>
                  <FormControl>
                    <>
                      <ErpMappingComponent
                        className="border-r-0 border-t-0 border-b-0 !mt-0 rounded-none  bg-white"
                        bindLabel="label"
                        bindValue="value"
                        options={erpListData}
                        parentOrderType={parentOrderType}
                        onChange={(listProp: any) => {
                          field.onChange(listProp);
                          form.handleSubmit(onSubmit)();
                        }}
                        value={field.value}
                        onBlur={() => {
                          form.handleSubmit(onSubmit)();
                          if (field.value === "") {
                            field.onChange(defaultValue);
                          }
                        }}
                      />
                    </>
                  </FormControl>
                </FormItem>
              )}
            />
          </ConditionRenderer>
          <ConditionRenderer condition={type === "domain"}>
            <FormField
              control={form.control}
              name="order_type"
              render={({ field }) => (
                <FormItem className="w-full text-left grid grid-cols-2 border items-center">
                  <FormLabel className="capitalize pl-3">Order Type</FormLabel>
                  <FormControl>
                    <>
                      <SelectWithSearch
                        className="border-r-0 border-t-0 border-b-0 !mt-0 rounded-none  bg-white"
                        bindValue="value"
                        bindLabel="label"
                        options={orderTypeList}
                        onChange={(listProp: any) => {
                          field.onChange(listProp);
                          form.handleSubmit(onSubmit)();
                        }}
                        value={field.value}
                        onBlur={() => {
                          form.handleSubmit(onSubmit)();
                          if (field.value === "") {
                            field.onChange(defaultValue);
                          }
                        }}
                      />
                    </>
                  </FormControl>
                </FormItem>
              )}
            />
          </ConditionRenderer>
          <ConditionRenderer condition={type === "entity"}>
            <FormField
              control={form.control}
              name="cardinality"
              render={({ field }) => (
                <FormItem className="w-full text-left grid grid-cols-2 border items-center">
                  <FormLabel className="capitalize pl-3">Cardinality</FormLabel>
                  <FormControl>
                    <>
                      <Select
                        value={field.value}
                        onValueChange={(prop) => {
                          field.onChange(prop);
                          form.handleSubmit(onSubmit)();
                        }}
                      >
                        <SelectTrigger
                          className="border-r-0 border-t-0 border-b-0 !mt-0 rounded-none  bg-white" /* className="w-full rounded-none" */
                        >
                          <>
                            <SelectValue placeholder="Select Cardinality" />
                          </>
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="1">1</SelectItem>
                          <SelectItem value="n">N</SelectItem>
                        </SelectContent>
                      </Select>
                    </>
                  </FormControl>
                </FormItem>
              )}
            />
          </ConditionRenderer>
        </form>
      </Form>
    </div>
  );
};
